<template>
  <AquassistPage>
    <template v-slot:content>
      <form>
        <v-row
          align="center"
          justify="center"
        >
          <span class="title white--text my-6">
            {{ $t('forms.labels.resetPassword') }}
          </span>
        </v-row>
        <ResetPasswordForm
          @validChanged="isFormValid = $event"
          @sendData="data = $event"
        />
        <v-row
          align="center"
          justify="center"
          class="mt-6"
        >
          <v-btn
            width="247"
            :disabled="!isFormValid"
            type="submit"
            color="secondary"
            @click.prevent="resetPassword"
          >
            {{ $t('forms.btn.reset') }}
          </v-btn>
        </v-row>
      </form>
    </template>
  </AquassistPage>
</template>

<script>
import AquassistPage from '@/components/login/AquassistPage.vue';
import ResetPasswordForm from '@/components/login/TheResetPasswordForm.vue';

export default {
    components: {
        ResetPasswordForm,
        AquassistPage,
    },
    data() {
        return {
            isFormValid: false,
            data: null,
        };
    },
    methods: {
        resetPassword() {
            this.$rq.postConfirmPasswordReset(this.data)
                .then(() => {
                    this.$toasted.global.toast_success({
                        message: this.$t('msg.passwordChanged'),
                    });
                    this.redirect();
                });
        },
        redirect() {
            this.$router.push('/login');
        },
    },
};
</script>
